export default str => {
  return str && str.split( '#' )[ 0 ]
}
